import PropTypes from 'prop-types'
import { Center, HStack, Text, VStack } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function NumberBody({ title, number, icon, notCurrency }) {
  return (
    <HStack p="18px" justifyContent="space-around">
      <VStack alignItems="flex-start">
        <Text variant="subtitle3">{title}</Text>
        <Text variant="h3">
          {notCurrency ? '' : '$'}
          {Number(number).toLocaleString('de-DE')}
        </Text>
      </VStack>
      <Center
        bgColor="#565656"
        w="45px"
        h="45px"
        borderRadius="12px"
        boxShadow="0px 3.5px 5.5px rgba(0, 0, 0, 0.02)"
      >
        <FontAwesomeIcon color="#FFFFFF" icon={icon} />
      </Center>
    </HStack>
  )
}

NumberBody.propTypes = {
  icon: PropTypes.any,
  number: PropTypes.number,
  title: PropTypes.string,
  notCurrency: PropTypes.bool,
}
